// extracted by mini-css-extract-plugin
module.exports = {"article":"SmallBlogCard_article__a_9_8","heading":"SmallBlogCard_heading__2or__","imgWrapper":"SmallBlogCard_imgWrapper__kAw30"};